// extracted by mini-css-extract-plugin
export default {"root":"OverlayLoader_root__oPud3"};